// E-Ticaret › Üyeler (Üye Yönetimi) sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.members';

export const ecommerceMembersGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Üye Yönetimi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'E-ticaret sitenize üye olan müşterilerinizi burada görürsünüz: iletişim bilgisi, sipariş ve harcama, satıcı başvurusu ve B2B (bayi) durumu. Bir üyeyi cari hesaba bağlayıp bayi olarak onaylamak da buradan yapılır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Üye Yönetimi'),
    stats: t(`${G}.regions.stats`, 'Özet kartları'),
    filters: t(`${G}.regions.filters`, 'Üye ara ve Durum Filtresi'),
    table: t(`${G}.regions.table`, 'Üye listesi ve ⋮ menüsü'),
    pagination: t(`${G}.regions.pagination`, 'Sayfalama'),
  },
  steps: [
    {
      region: 'stats',
      title: t(`${G}.s1.title`, '1. Özet kartlarını okuyun'),
      text: t(`${G}.s1.text`, 'Kartlar Toplam Üye, Aktif Üye (aktif ve engelli olmayan), Bu Ay Yeni (bu ay kayıt olan) ve Toplam Ciro (tüm üyelerin toplam harcaması) değerlerini gösterir.'),
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Üyeyi bulun'),
      text: t(`${G}.s2.text`, '"Üye ara..." kutusuna ad, soyad, e-posta veya telefon yazın. "Durum Filtresi" ile Tümü, Aktif veya Engelli üyeleri gösterin.'),
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Sipariş ve harcama bilgisini okuyun'),
      text: t(`${G}.s3.text`, 'Her satırda üyenin adı, iletişim bilgisi, durumu (Aktif / Pasif / Engelli), kayıt tarihi ve son girişi, sipariş sayısı ve toplam harcaması görünür. ⋮ menüsündeki "Detayları Görüntüle" kişisel bilgileri, toplam sipariş, toplam harcama ve ortalama sepet tutarını; "Sepeti Görüntüle" üyenin sepetindeki ürünleri gösterir.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. B2C / B2B ayrımı ve satıcı başvurusu'),
      text: t(`${G}.s4.text`, '"B2B / Cari" sütununda normal (bireysel) müşteriler "B2C" olarak görünür. Bayi olarak işaretlenen üyelerde "B2B Onaylı" veya "B2B Onay Bekliyor" etiketi ve bağlı olduğu cari hesabın adı yer alır. "Satıcı Olma Başvurusu" sütunu üyenin satıcı başvurusunun durumunu gösterir: Yok, Yapıldı (bekliyor), Onaylandı, Reddedildi.'),
      tips: [
        t(`${G}.s4.tip1`, 'Satıcı başvuruları bu ekranda yalnız görüntülenir; onay / ret bu ekrandan yapılmaz.'),
        t(`${G}.s4.tip2`, 'Başvurular yüklenemezse listenin üstünde uyarı çıkar ve sütunda yalnız "Yok" görünebilir.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Üyeyi cariye bağlayın, B2B onaylayın'),
      text: t(`${G}.s5.text`, '⋮ menüsünden "Cariye Bağla / B2B" seçin. "Cari Hesap" listesinden üyenin cari hesabını seçin; "B2B üye (bayi)" ile üyeyi bayi olarak işaretleyin, "B2B onaylı (giriş/iskonto aktif)" ile bayiliği onaylayın ve "Bağla ve Kaydet"e basın.'),
      tips: [
        t(`${G}.s5.tip1`, 'Üye bir cariye bağlandığında faturalar bu cariye kesilir.'),
        t(`${G}.s5.tip2`, 'B2B işaretli ve onaylı üyeler cari iskontosu görür ve cariden ödeme yapabilir. "B2B onaylı" seçeneği yalnız "B2B üye (bayi)" işaretliyken seçilebilir.'),
        t(`${G}.s5.tip3`, '"Cari Bağını Kaldır" cari bağlantısını ve B2B / B2B onaylı işaretlerini birlikte kaldırır.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s6.title`, '6. Durum değiştirme ve silme'),
      text: t(`${G}.s6.text`, '⋮ menüsünde "Engelle" / "Engeli Kaldır" ve "Sil" seçenekleri de bulunur. Silme işlemi onay ister ve geri alınamaz.'),
      tips: [
        t(`${G}.s6.tip1`, 'Liste uzunsa alttaki sayfalama ile ilerleyin. Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
      ],
    },
  ],
});
